import React from 'react'
import { FormNewButtonBack } from './form-button-back'
import { FormNewButtonSubmit } from './form-button-submit'

export const FormNewButtonSubmitBack = ({ submitText, backUrl }) => {
  return (
    <React.Fragment>
      <FormNewButtonBack text="Back" url={backUrl} />
      <FormNewButtonSubmit text={submitText || 'Submit'} />
    </React.Fragment>
  )
}

export const FormNewButtonCreateBack = ({ backUrl }) => {
  return (
    <React.Fragment>
      <FormNewButtonBack text="Back" url={backUrl} />
      <FormNewButtonSubmit text="Create" />
    </React.Fragment>
  )
}

export const FormNewButtonUpdateBack = ({ backUrl }) => {
  return (
    <React.Fragment>
      <FormNewButtonBack text="Back" url={backUrl} />
      <FormNewButtonSubmit text="Update" />
    </React.Fragment>
  )
}
